// Module
var code = "<variant-suppliers\n  article-id=\"vm.variant.article.id\"\n  variant-id=\"vm.variant.id\"\n  pd-variant=\"vm.variant.isProductDevelopment\"\n></variant-suppliers>\n";
// Exports
module.exports = code;